import { AlertTriangle, UserRoundMinus, X } from 'lucide-react';
import { useDeleteOffer } from "../hooks/useDeletedOffer";

export const DeleteOfferModal = (props) => {
    const { isDeleteModalOpen, setIsDeleteModalOpen, offer } = props;
    const { mutate: deleteOffer, isPending } = useDeleteOffer();

    const handleDelete = () => {
        deleteOffer(offer._id, {
            onSuccess: () => {
                setIsDeleteModalOpen(false);
            },
        });
    };

    if (!isDeleteModalOpen || !offer) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
            <div className="bg-gray-900 rounded-lg shadow-xl w-full max-w-md border border-gray-800">
                {/* Header */}
                <div className="flex items-center justify-between px-6 py-4 border-b border-gray-800">
                    <div className="flex items-center space-x-2">
                        <AlertTriangle className="text-red-500" size={20} />
                        <h3 className="text-lg font-semibold text-white">Confirm Delete</h3>
                    </div>
                    <button
                        onClick={() => setIsDeleteModalOpen(false)}
                        className="text-gray-400 hover:text-white transition-colors"
                    >
                        <X size={20} />
                    </button>
                </div>

                {/* Content */}
                <div className="p-6">
                    <p className="text-gray-300 mb-4">
                        Are you sure you want to delete{" "}
                        <span className="font-semibold text-white">{offer?.title}</span>? This action cannot be undone.
                    </p>

                    {/* Buttons */}
                    <div className="flex space-x-3">
                        <button
                            onClick={() => setIsDeleteModalOpen(false)}
                            className="flex-1 px-4 py-2 border border-gray-700 rounded-md text-gray-300 hover:bg-gray-800 transition-colors"
                            disabled={isPending}
                        >
                            Cancel
                        </button>
                        <button
                            onClick={handleDelete}
                            className="flex-1 px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                            disabled={isPending}
                        >
                            {isPending ? (
                                <div className="flex items-center justify-center">
                                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2" />
                                    Deleting...
                                </div>
                            ) : (
                                "Delete"
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}